export const MOBILE_BREAKPOINT = 992;
